import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Modal from 'components/modal'
import Font from '@cred/react-font'
import actions from '@cred/react-modal/actions'
import styles from './styles.module.scss'

const MODAL_SUFFIX = '-modal',
  setModalName = name => `${name}${MODAL_SUFFIX}`,
  DisclosureModal = ({ name, title, children, openModal, closeModal, vertical }) => (
    <>
      <Font type="disclaimer" className={vertical === 'savings' ? styles.secondaryDisclaimer : styles.disclaimer} onClick={openModal}>{title}</Font>
      <section className={styles.modal}>
        <Modal hideHeader withoutPadding dismiss name={setModalName(name)}>
          <Font className={`${styles.header} align-center`} type="bodySmall" weight="bold" color="neutral">{title}</Font>
          <Font element="div" className={styles.content}>{children}</Font>
          <div className={styles.footer}>
            <Font className="align-right" color="neutral" onClick={closeModal}>Close</Font>
          </div>
        </Modal>
      </section>
    </>
  ),
  mapDispatchToProps = (dispatch, props) => {
    const { name } = props,
      { openModal, closeModal } = actions,
      modalName = setModalName(name)

    return {
      openModal: () => dispatch(openModal(modalName)),
      closeModal: () => dispatch(closeModal(modalName)),
    }
  }
DisclosureModal.defaultProps = {
  vertical: 'default',
}
DisclosureModal.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.element,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
  vertical: PropTypes.string,
}

export { DisclosureModal, setModalName, mapDispatchToProps }

export default connect(
  null,
  mapDispatchToProps,
)(DisclosureModal)
